import React, { useState, memo } from 'react';

const Headers = props => {
    /** the columns of the datatable*/
    const headers = [
        {
            icon: "far fa-clock",
            label: "created_at",
            dir: 'asc'
        },
        {
            icon: "fas fa-chair",
            label: "seat",
            dir: 'asc'
        },
        {
            icon: "fas fa-shopping-cart",
            label: null,
            dir: 'asc',
            extraClasses: 'd-none d-md-block'
        },
        {
            icon: "fas fa-dollar-sign",
            label: "total_paid",
            dir: 'asc'
        },
        {
            icon: "fas fa-check",
            label: "status",
            dir: 'asc',
            extraClasses: 'd-none d-md-block'
        },
        {
            icon: "fas fa-tools",
            label: null,
            dir: 'asc'
        }
    ];
    /** store  the headers */
    const [heardersBtn, setHeadersBtn] = useState(headers);
     /** return the headers */
    const Columns = () => heardersBtn.map(
        (header, index) => {
            return <div className={`col-3 col-sm-3 col-md-2 text-center ${(typeof (header.extraClasses) !== "undefined") ? header.extraClasses : ''}`} key={index}>
                <button onClick={() => {
                    props.sortBy(header);
                    let i = heardersBtn.indexOf(header);
                    let t = [...heardersBtn];
                    t[i].dir = (t[i].dir === "asc") ? "desc" : "asc";
                    setHeadersBtn(t);
                }} className="align-items-center btn btn-secondary d-flex h-100 justify-content-around text-center w-100 p-2">
                    {
                        ((header.label !== null) && (header.dir !== "asc")) &&
                        <i className={`fas fa-angle-double-down`}></i>
                    }
                    <i className={`fa-2x ${header.icon}`} />
                </button>
            </div>
        }
    )

    return <div className="row justify-content-between pt-3 pb-3 bg-light position-sticky top-60px z-index-1">
        <Columns />
    </div>
}
export default memo(Headers);